import React from 'react';
import { VideoSlashIcon } from 'components/icons';

export function VideoCameraInaccessible(props: {
  text?: string;
}): React.ReactElement {
  const { text } = props;
  return (
    <div className="odin-flex odin-h-full odin-flex-col odin-items-center odin-justify-center">
      <VideoSlashIcon className="odin-mb-2 odin-h-6 odin-w-6 odin-text-slate-400" />
      {text && <p className="odin-text-md odin-text-slate-500">{text}</p>}
    </div>
  );
}
